import React from 'react';
import classnames from 'classnames';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { ICircularProgressBarProps, IPathColorTypes } from './types';
import styles from './styles.module.scss';

const CircularProgressBar = (props: ICircularProgressBarProps) => {
  const {
    children,
    className,
    valuePercent,
    minValue = 0,
    maxValue = 100,
    strokeWidth = 5,
    color = IPathColorTypes.PRIMARY,
  } = props;

  const classNames = classnames(className);

  return (
    <CircularProgressbarWithChildren
      className={classNames}
      value={valuePercent}
      minValue={minValue}
      maxValue={maxValue}
      strokeWidth={strokeWidth}
      classes={{
        root: '',
        path: styles[color],
        text: '',
        trail: '',
        background: '',
      }}
      styles={{
        path: {
          strokeLinecap: 'butt',
          transition: 'stroke-dashoffset 0.5s ease 0s',
        },
      }}
    >
      {children}
    </CircularProgressbarWithChildren>
  );
};

export { IPathColorTypes };

export default CircularProgressBar;
